import { apiClient } from "@/lib/apiClient";

export interface DashboardMetrics {
  totalSessions: {
    total: number;
    trend: number;
  };
  activeSessions: number;
  avgSessionDuration: number;
  sessionsByType: {
    call: number;
    web_voice: number;
    web_chat: number;
  };
  sessionTrend: Array<{
    date: string;
    sessions: number;
  }>;
  topCompanies: Array<{
    id: string;
    name: string;
    sessionCount: number;
    lastActivity: string;
    growth: number;
  }>;
  analysisMetrics?: {
    avgOverallScore: number;
    qualityScoreTrend: number;
    objectiveAchievedRate: number;
    customerSatisfactionRate: number;
    avgConversationQuality: {
      responseAppropriateness: number;
      conversationFlow: number;
      informationAccuracy: number;
      clarityOfCommunication: number;
      professionalTone: number;
      empathyAndRapport: number;
    };
    technicalPerformance: {
      toolSuccessRate: number;
      audioIssuesPercent: number;
      systemErrorsCount: number;
      topFunctionCalls: Array<{ name: string; count: number }>;
    };
    efficiencyMetrics: {
      avgTimeToResolution: string;
      deadAirPercent: number;
      unnecessaryRepetitionPercent: number;
    };
    analyzedSessionsCount: number;
    totalSessionsCount: number;
  };
}

export const dashboardApi = {
  async getDashboardMetrics(
    companyId?: string,
    days: number = 30
  ): Promise<DashboardMetrics> {
    const params = new URLSearchParams();
    if (companyId) {
      params.append("companyId", companyId);
    }
    params.append("days", days.toString());

    const response = await apiClient.get<DashboardMetrics>(
      `/v1/dashboard/metrics?${params.toString()}`
    );
    return response;
  },
};
